module.exports = __webpack_public_path__ + "media/images/new-ui-images/simple-cross-26b1e26ff13246f83402d477f43c26f8.svg";